import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { login as loginApi, getMe } from '@/api/auth';
import { usePermissionStore } from '@/stores/permission';
import { useAiModelStore } from '@/stores/aiModel';

export const useUserStore = defineStore('user', () => {
    const token = ref(localStorage.getItem('geo_token') || '');
    const userInfo = ref(null);
    const permissions = ref([]);

    const isLoggedIn = computed(() => !!token.value);

    async function login(credentials) {
        const res = await loginApi(credentials);
        token.value = res.token;
        userInfo.value = res.user;
        permissions.value = res.permissions || [];
        localStorage.setItem('geo_token', res.token);
        // 切换账号时必须同步刷新权限 store，
        // 否则守卫看到 loaded=true 会沿用上一个账号的权限，菜单就是错的
        const permissionStore = usePermissionStore();
        permissionStore.permissions = res.permissions || [];
        permissionStore.loaded = true;
        // AI 生成偏好按账号隔离：绑定当前账号并载入他存在数据库里的偏好
        useAiModelStore().bindUser(res.user);
        return res;
    }

    async function fetchUserInfo() {
        const res = await getMe();
        userInfo.value = res;
        // 刷新页面恢复会话后，同样绑定账号（载入该账号的 AI 生成偏好）
        useAiModelStore().bindUser(res);
        return res;
    }

    function logout() {
        token.value = '';
        userInfo.value = null;
        permissions.value = [];
        localStorage.removeItem('geo_token');
        // 一并清空权限缓存，避免下个账号沿用旧权限
        const permissionStore = usePermissionStore();
        permissionStore.permissions = [];
        permissionStore.loaded = false;
        // 解绑账号，避免下个账号看到上一个账号的 AI 平台选择
        useAiModelStore().bindUser(null);
        // 整页跳转：清空内存中的一切残留（定时器、组件状态、store）
        // 退出后回官网首页而非登录页（官网是公开门面，想再进后台从头部点登录即可）
        window.location.href = '/';
    }

    return {
        token,
        userInfo,
        permissions,
        isLoggedIn,
        login,
        fetchUserInfo,
        logout
    };
});
